import { Flex } from '@chakra-ui/layout';
import React from 'react';

interface PageContainerProps {
  center?: boolean;
  isHeader?: boolean;
}

export const PageContainer: React.FC<PageContainerProps> = ({
  children,
  center,
  isHeader,
}) => (
  <Flex
    minH={`calc(100vh - ${isHeader ? '150' : '50'}px)`}
    px={[3, 6]}
    pt={[3, 8]}
    pb={[3, 6]}
    maxWidth="1200px"
    m="0 auto"
    justify={center ? 'center' : 'flex-start'}
    direction="column"
  >
    {children}
  </Flex>
);
